import React, {useState} from 'react';
import queryString from "query-string";
import messages from "res/messages/farsi";
import Urls from "../../../connection/Urls";
import {callApi} from "../../../connection/ClientApi";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import {useHistory} from "react-router-dom";
import IconRichTextView from "components/input/IconRichTextView";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import {Divider} from "@material-ui/core";
import {getButtonHeight, IsF, IsM, IsSM, IsT} from "my-styles/media/media";

import ICOrderRate from 'res/images/order_rate.png';
import ICFantasticBg2 from "res/images/fantastic_bg_2.png";
import ICDoneIcon from "res/images/done_white.png";
import ICMessage from "res/images/message.png";
import ICAngry from "res/images/angry.png";
import ICVerySad from "res/images/verySad.png";
import ICPoker from "res/images/poker.png";
import ICHappy from "res/images/happy.png";
import ICVeryHappy from "res/images/very_happy.png";
import ICLovely from "res/images/lovely.png";

export const RATE_STATUS = {
    ANGRY: 1,
    SAD: 2,
    POKER: 3,
    HAPPY: 4,
    VERY_HAPPY: 5,
    LOVELY: 6
}

export default function OrderRate(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [rateList] = useState([
        {
            status: RATE_STATUS.LOVELY,
            selected: false,
            icon: ICLovely
        },
        {
            status: RATE_STATUS.VERY_HAPPY,
            selected: false,
            icon: ICVeryHappy
        },
        {
            status: RATE_STATUS.HAPPY,
            selected: false,
            icon: ICHappy
        },
        {
            status: RATE_STATUS.POKER,
            selected: false,
            icon: ICPoker
        },
        {
            status: RATE_STATUS.SAD,
            selected: false,
            icon: ICVerySad
        },
        {
            status: RATE_STATUS.ANGRY,
            selected: false,
            icon: ICAngry
        }
    ])
    const [selectedRate, setSelectedRate] = useState()
    const [description, setDescription] = useState()

    function requestRateOrder() {
        let params = new FormData()
        params.append("order_id", urlParams.order_id)
        params.append("rate", selectedRate.status)
        params.append("description", description ? description : "")
        callApi(Urls.rateOrder, params, (data) => {
            if (data.description === 200) {
                props.onAlert(data.message, ALERT_TYPES.SUCCESS)
                props.onNavigate(history, '/')
            } else {
                props.onAlert(data.message, ALERT_TYPES.ERROR)
            }
        }, (data) => {
            props.onAlert(data.message)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    return (IsSM() || IsM() ?
        <div className="marginSmall" style={{
            backgroundImage: 'url(' + ICFantasticBg2 + ')',
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>
            <table className="fullWidth center" style={{height: "35em"}}>
                <tbody>
                <tr>
                    <td>
                        <center>
                            <div className="twoFromThree largeTextBold">
                                {messages.rateOrderText_1}{urlParams.order_id}{messages.rateOrderText_2}
                            </div>
                            <div className="twoFromThree marginTopSmall">
                                <Divider/>
                            </div>
                            <table className="twoFromThree marginTopSmall">
                                <tr>
                                    {rateList.map((item, index) => {
                                        return <td
                                            key={index}
                                            className={selectedRate && item.status === selectedRate.status ? "border_blue" : "border_transparent"}>
                                            <img className="fullWidth" src={item.icon} alt=""
                                                 onClick={() => {
                                                     setSelectedRate(item)
                                                 }}
                                            />
                                        </td>
                                    })}
                                </tr>
                            </table>
                            <div className="threeFromFour">
                                <IconRichTextView
                                    height={"4em"}
                                    placeholder={messages.description}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICMessage} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setDescription(e.target.value)
                                    }}/>
                            </div>
                            <div className="threeFromFour marginTopBottomLarge">
                                <IconTitleButtonRound
                                    height={getButtonHeight()}
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        if (selectedRate) {
                                            requestRateOrder()
                                        } else {
                                            props.onAlert(messages.pleaseSelectRate)
                                        }
                                    }}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon} className="marginSmall xSmallIcon"/>}
                                    title={messages.addRate}/>
                            </div>
                        </center>
                    </td>
                </tr>
                </tbody>
            </table>
        </div> :
        IsF() ?
            <div className="marginSmall" style={{
                backgroundImage: 'url(' + ICFantasticBg2 + ')',
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>
                <table className="fullWidth center" style={{height: "35em"}}>
                    <tbody>
                    <tr>
                        <td>
                            <center>
                                <div style={{width: "55%"}} className="largeTextBold">
                                    {messages.rateOrderText_1}{urlParams.order_id}{messages.rateOrderText_2}
                                </div>
                                <div style={{width: "55%"}} className="marginTopSmall">
                                    <Divider/>
                                </div>
                                <table style={{width: "55%"}} className="marginTopBottomMedium">
                                    <tbody>
                                    <tr>
                                        {rateList.map((item, index) => {
                                            return <td
                                                key={index}
                                                className={selectedRate && item.status === selectedRate.status ? "border_blue" : "border_transparent"}>
                                                <img className="fullWidth" src={item.icon} alt=""
                                                     onClick={() => {
                                                         setSelectedRate(item)
                                                     }}
                                                />
                                            </td>
                                        })}
                                    </tr>
                                    </tbody>
                                </table>
                                <div style={{width: "55%"}}>
                                    <IconRichTextView
                                        height={"8em"}
                                        placeholder={messages.description}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICMessage} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setDescription(e.target.value)
                                        }}/>
                                </div>
                                <div style={{width: "55%"}} className="marginTopBottomLarge">
                                    <IconTitleButtonRound
                                        height={getButtonHeight()}
                                        fontSize="mediumTextBold"
                                        onClick={() => {
                                            if (selectedRate) {
                                                requestRateOrder()
                                            } else {
                                                props.onAlert(messages.pleaseSelectRate)
                                            }
                                        }}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon} className="marginSmall xSmallIcon"/>}
                                        title={messages.addRate}/>
                                </div>
                            </center>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div> :
            IsT() ?
                <div className="marginSmall" style={{
                    backgroundImage: 'url(' + ICFantasticBg2 + ')',
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                    <table className="fullWidth center" style={{height: "35em"}}>
                        <tbody>
                        <tr>
                            <td>
                                <center>
                                    <div style={{width: "40%"}} className="largeTextBold">
                                        {messages.rateOrderText_1}{urlParams.order_id}{messages.rateOrderText_2}
                                    </div>
                                    <div style={{width: "40%"}} className="marginTopSmall">
                                        <Divider/>
                                    </div>
                                    <table style={{width: "40%"}} className="marginTopBottomMedium">
                                        <tbody>
                                        <tr>
                                            {rateList.map((item, index) => {
                                                return <td
                                                    key={index}
                                                    className={selectedRate && item.status === selectedRate.status ? "border_blue" : "border_transparent"}>
                                                    <img className="fullWidth" src={item.icon} alt=""
                                                         onClick={() => {
                                                             setSelectedRate(item)
                                                         }}
                                                    />
                                                </td>
                                            })}
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div style={{width: "40%"}}>
                                        <IconRichTextView
                                            height={"8em"}
                                            placeholder={messages.description}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICMessage} className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setDescription(e.target.value)
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}} className="marginTopBottomLarge">
                                        <IconTitleButtonRound
                                            height={getButtonHeight()}
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                if (selectedRate) {
                                                    requestRateOrder()
                                                } else {
                                                    props.onAlert(messages.pleaseSelectRate)
                                                }
                                            }}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon} className="marginSmall xSmallIcon"/>}
                                            title={messages.addRate}/>
                                    </div>
                                </center>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div> :
                <div className="horizontalScreen marginLarge">
                    <div className="formContainerLarge">
                        <img className="lowZIndex full" src={ICFantasticBg2} alt=""/>
                        <table className="full" style={{position: "absolute", top: "0"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <center>
                                        <div className="twoFromThree largeTextBold">
                                            {messages.rateOrderText_1}{urlParams.order_id}{messages.rateOrderText_2}
                                        </div>
                                        <div className="twoFromThree marginTopSmall">
                                            <Divider/>
                                        </div>
                                        <table className="twoFromThree marginTopBottomMedium">
                                            <tbody>
                                            <tr>
                                                {rateList.map((item, index) => {
                                                    return <td
                                                        key={index}
                                                        className={selectedRate && item.status === selectedRate.status ? "border_blue" : "border_transparent"}>
                                                        <img className="fullWidth" src={item.icon} alt=""
                                                             onClick={() => {
                                                                 setSelectedRate(item)
                                                             }}
                                                        />
                                                    </td>
                                                })}
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div className="threeFromFour">
                                            <IconRichTextView
                                                height={"8em"}
                                                placeholder={messages.description}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICMessage}
                                                           className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setDescription(e.target.value)
                                                }}/>
                                        </div>
                                        <div className="threeFromFour marginTopBottomLarge">
                                            <IconTitleButtonRound
                                                height={getButtonHeight()}
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    if (selectedRate) {
                                                        requestRateOrder()
                                                    } else {
                                                        props.onAlert(messages.pleaseSelectRate)
                                                    }
                                                }}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon}
                                                           className="marginSmall xSmallIcon"/>}
                                                title={messages.addRate}/>
                                        </div>
                                    </center>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="halfWidth" style={{position: "absolute", left: 0, top: "15%"}}>
                        <img className="leftSideBg" src={ICOrderRate} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                    </div>
                </div>)

}